import { Form } from "antd";
import FormInputNumber from "component/form/form_input_number";
import React from "react";
import { useSelector } from "react-redux";
import { defaultWalletAllSelector } from "store/bailiff/default/wallet/default_wallet.selector";
import { settingWithdrawAllSelector } from "store/bailiff/default/withdraw/setting_withdraw.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const WithdrawAmount = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;

  console.log({ code });
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const wallet = useSelector(defaultWalletAllSelector);
  const setting = useSelector(settingWithdrawAllSelector);
  const min = setting?.min || 500000;
  const amount = wallet?.earn;
  const max = amount >= 200000 ? amount : 200000;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------

  return (
    <FormInputNumber
      style={{
        width: "100%",
        height: 40,
        alignItems: "center",
        display: "flex",
      }}
      name="amount"
      label="Số tiền bạn muốn rút"
      min={min}
      max={max}
      variant="filled"
      disabled={!code}
      rules={[
        {
          required: true,
          message: "Không được để trống",
        },
      ]}
    />
  );
};
export default WithdrawAmount;
